import styles from '@/styles/swiper.module.scss'
import SwiperSelf from '@/components/SwiperSelf'
import { SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import { useState } from "react"
import { matomoSetCustomDimension } from '@/utils/matomoEvent';

interface BannerItem {
  imgUrl: string;
  title: string;
  link: string;
}

interface props {
  bannerList: BannerItem[];
}

export default function Swiper({ bannerList }: props) {
  function handlePageJump() {
    // ReactGA.event({
    //   category: 'New Home Page',
    //   action: 'Click',
    //   label: `Slider - ${banner.title}`,
    // });
    // window.location.href = "https://" + window.location.host + banner.link
  }

  /**
   * UVP 的 AB test
   */
  const [abTestVersion] = useState('A');

  //  useEffect(() => {
  //    // 先看看cookie，当前是A还是B，cookie没有的话，从abTestCalculate拿
  //    if (getCookie('X-Service-Group-AB')) {
  //      setAbTestVersion(getCookie('X-Service-Group-AB') || 'A')
  //    } else {
  //      abTestCalculate("2024-02-05_ABTest").then((res: unknown) => {
  //        console.log(`Once you enter the page, the traffic starts being counted, and the traffic falls on ${res as string}`)
  //        setAbTestVersion(res as string || 'A');
  //      })
  //    }
  //  }, []);


  return (
    <div className={styles['swiper-box']}>
      <SwiperSelf slidesPerView={1} pagination={true} loop={true} autoplay={true}>
        {
          bannerList.map((banner:any,index:number) =>
            <SwiperSlide
              key={banner.link}
              onClick={() => {
                matomoSetCustomDimension(15, banner.title);
                matomoSetCustomDimension(16, index + 1);
              }}
            >
              <Link
                href={banner.link}
                legacyBehavior
              >
                <a
                  target="_blank"
                  title={banner.title}
                  rel="noopener noreferrer"
                  style={{ display: 'block' }}
                >
                  <div
                    className={styles['banner-item-bg']}
                    style={{ height: `${abTestVersion == 'A' ? '400px' : '400px'}`, backgroundImage: `url('${banner.imgUrl}')` }}
                    onClick={() => handlePageJump()}
                  ></div>
                </a>
              </Link>
            </SwiperSlide>
          )
        }
      </SwiperSelf>
    </div>
  )
}
